  const h1 = "background: #00dd94;; color: white; font-size: x-large; padding: 5px"
  const p = "color: black; font-size: large"
  console.log("%cHledáme posily!", h1);
  console.log("%cZajímá tě progresivní webový vývoj třeba v Reactu? Chceš si zkusit nativní vývoj mobilních appek v React Native? Použít moderní technologie jako Firebase nebo Node.js?", p);
  console.log("%cMrkni na virtii.com a nebo napiš na hello@virtii.com!", h1);



// WEBPACK FOOTER //
// ./src/browser/lib/hiring.js